import { create } from 'zustand';
import { OrderTypeEnum } from './useOrderTypeStore';
import { ISearch } from '@/hooks/useSearchStore';
import { Dayjs } from 'dayjs';

export interface OrderFilters {
  searchValue?: ISearch;
  createdAtFilter?: [Dayjs, Dayjs];
  orderTypeFilter?: OrderTypeEnum[];
  carrierFilter?: string[];
  printedFilter?: boolean;
}

interface StoreAndActions extends OrderFilters {
  currentPage: number;

  setCurrentPage: (page: number) => void;
  setSearchValue: (value: ISearch) => void;
  setCreatedAt: (value?: [Dayjs, Dayjs]) => void;
  setOrderType: (value: OrderTypeEnum[]) => void;
  setCarrier: (value: string[]) => void;
  setPrinted: (value?: boolean) => void;
  resetFilers: () => void;
}

export const emptySearchValue = { search: null, searchBy: null };

const useFilterOrderStore = create<StoreAndActions>((set, get) => ({
  currentPage: 1,
  searchValue: emptySearchValue,
  createdAtFilter: undefined,
  orderTypeFilter: [],
  carrierFilter: [],
  printedFilter: undefined,

  setCurrentPage: (page) => set({ currentPage: page }),
  setSearchValue: (value) => set({ searchValue: value }),
  setCreatedAt: (value) => set({ createdAtFilter: value }),
  setOrderType: (value) => set({ orderTypeFilter: [...value] }),
  setCarrier: (value) => set({ carrierFilter: [...value] }),
  setPrinted: (value) => set({ printedFilter: value }),
  resetFilers: () => {
    set({
      currentPage: 1,

      createdAtFilter: undefined,
      orderTypeFilter: [],
      carrierFilter: [],
      printedFilter: undefined,
      searchValue: emptySearchValue,
    });
  },
}));

export default useFilterOrderStore;
